document.addEventListener("DOMContentLoaded", function () {
  const bubbles = document.querySelectorAll(".bubble");
  const tooltip = document.getElementById("tooltip");
  const announcement = document.getElementById("shopify-section-announcement-bar").offsetHeight;
  const header = document.querySelector(".header").offsetHeight;
  const contentImageMobile = document.querySelector(".js-slider-img-mobile").offsetHeight;
  const title =document.querySelector("h1.product__title").offsetHeight;

  function showTooltip(message,rect,index) {
    tooltip.textContent = message;
    tooltip.style.display = "block";
    const tooltipHeight = tooltip.offsetHeight;
    let left, top;

    if(window.innerWidth > 768){
      if(index===0 || (window.innerWidth > 768 && window.innerWidth < 990)){
        left = 0;
      }else{
        left = index*(rect.width / 2) ;
      }
      
      if (window.innerWidth > 768 && window.innerWidth < 990) {
        top = rect.top-announcement-header-title - tooltipHeight +25+ window.scrollY;
      } else if (window.innerWidth >= 990) {
        top = rect.top - announcement-header-title - tooltipHeight - 15 + window.scrollY;
      };
    } else{
      left = 0;
      top = rect.top-announcement-header-contentImageMobile-title - tooltipHeight - 10 + window.scrollY;
    }
     
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
  }

  function hideTooltip() {
    tooltip.style.display = "none";
  }

  bubbles.forEach((bubble, index) => {
    bubble.addEventListener("mouseenter", (event) => {
      if (window.innerWidth > 768) {
        // Desktop
        const message = bubble.dataset.tooltip;
        if (message) {
          const rect = bubble.getBoundingClientRect();
          showTooltip(message, rect, index);
        }
      }
    });

    bubble.addEventListener("mouseleave", () => {
      if (window.innerWidth > 768) {
        // Desktop
        hideTooltip();
      }
    });

    bubble.addEventListener("click", (event) => {
      if (window.innerWidth <= 768) {
        // Mobile
        const message = bubble.dataset.tooltip;
        if (message) {
          const rect = bubble.getBoundingClientRect();
          if(tooltip.style.display === "block" && tooltip.textContent === message){
            hideTooltip();
          }else{
            showTooltip(message, rect, index);
          }
          
        }
      }
    });
  });

  document.addEventListener("click", (event) => {
    if (window.innerWidth <= 768 && !event.target.classList.contains("bubble")) {
      hideTooltip();
    }
  });
});
